import { render, staticRenderFns } from "./WebixScheduler.vue?vue&type=template&id=f3585968&"
import script from "./WebixScheduler.vue?vue&type=script&lang=js&"
export * from "./WebixScheduler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports